import React from "react";

import { RejectIcon } from "@/Components/Icons/RejectIcon";

/**
 * Function component for rendering the FilterModalTop.
 *
 * @param {function} handleClose - A function to handle the close action
 * @return {JSX.Element} The rendered JSX element
 */
export const FilterModalTop = ({ handleClose }) => {
  return (
    <div className="flex justify-between">
      <h3 className="text-[20px] font-semibold leading-[normal] text-black">
        Filter By
      </h3>
      <button onClick={handleClose} className="text-red outline-none ring-0">
        <RejectIcon />
      </button>
    </div>
  );
};
